﻿export default class IncomeTaxService {

    async getTax(income, year, table = 30, column = 1) {

        if (!year) {
            year = new Date().getFullYear();
        }
        const url = `/api/IncomeTax/GetTax?income=${income}&year=${year}&table=${table}&column=${column}`;

        const response = await fetch(url);

        if (response.ok) {
            return await response.text();
        }

        throw new Error("Couldn't get Tax");

    }

    async getIncomeAfterTax(income, year, table = 30, column = 1) {

        if (!year) {
            year = new Date().getFullYear();
        }

        const url = `/api/IncomeTax/GetIncomeAfterTax?income=${income}&year=${year}&table=${table}&column=${column}`;
        const response = await fetch(url);

        if (response.ok) {
            return await response.text();
        }

        throw new Error("Couldn't get IncomeAfterTax");

    }

};